import React from 'react';
import moment from 'moment';
import * as bootstrap from 'bootstrap';
import { ArrowDownCircle32, CheckCircleFill, Info } from '../../components/tools/Icons';
import { LoadingPage } from '../../components/tools/Others';
import { convertSimCardActivationProcessAuditAudit, convertSimCardActivationProcessStatus } from '../../helpers/converters';
import { UneditableTextInput } from '../../components/tools/BootstrapControls';
import uiHelpers from '../../helpers/uiHelpers';
import * as apiCaller from '../../helpers/apiCaller'
import serviceUrls from '../../constants/serviceUrls';
import SimActivationProcess from './SimActivationProcess';

export default class SimActivationProcessDetails  extends React.Component {

    processId;

    constructor(props) {
        super(props);
        this.processId = parseInt(props.match.params.id);
    }


    render() {
        return <>
            <h3 class="mb-3">
                Sim Activation Process
            </h3>
            <SimActivationProcess processId={this.processId} disableBtns={true} displayRelatedForms={true}/>
        </>
    }

}